import { handleSubmit } from '../../components/ProgressiveFormStepper/utils';
import { formatOption } from '../../handlers/utils';
import { getResumeOrSectionIndex } from '../../handlers';
import { removeCheckedItem } from '../Checkboxes/utils';
import { runAxios } from '../../handlers/axios';

export const compare = (a, b) => {
  if (a.value < b.value) {
    return -1;
  }
  if (a.value > b.value) {
    return 1;
  }
  return 0;
};

/**
 *
 * @param props
 * @param qObj
 */
export const handleNewExpertiseCheckbox = (props, qObj) => {
  const addButton = document.querySelector('#addAnother_' + qObj.qid);
  const value = addButton.value;
  let add = value.trim().length > 0;
  if (qObj.options) {
    for (let i = 0; i < qObj.options.length; i++) {
      if (qObj.options[i].key === value) {
        add = false;
        break;
      }
    }
  }
  if (add) {
    const newCheckBoxValue = { label: value, key: value, value: value };
    qObj.options.push(newCheckBoxValue);
    const index = getResumeOrSectionIndex(props.stateProps, props.formikProps);
    if (!props.formikProps.values.jobSeekerData[index][qObj.qid]) {
      props.formikProps.values.jobSeekerData[index][qObj.qid] = [];
    }
    props.formikProps.values.jobSeekerData[index][qObj.qid].push(value);
    let counter = props.stateProps.counter;
    props.stateProps.setCounter(counter + 1);
  }
  addButton.value = '';
  props.stateProps.setCounter(props.stateProps.counter + 1);
};
/**
 *
 * @param props
 * @param e
 * @param qid
 * @param qValue
 * @param index
 */
export const handleExpertiseCheckbox = (props, e, qid, qValue, index) => {

  const isChecked = e.currentTarget.checked;
  const secPart = props.formikProps.values.jobSeekerData[index];
  secPart[qid] = typeof secPart[qid] !== 'undefined' ? secPart[qid] : [];
  if (isChecked) {
    props.formikProps.values.jobSeekerData[index][qid].push(qValue);
  } else {
    removeCheckedItem(props, index, qid, qValue);
  }
  handleSubmit(props, 'computer-skills');
  props.stateProps.setCounter(props.stateProps.counter + 1);
};
/**
 *
 * @param industryOption
 * @returns {*}
 */
export const formatIndustryOption = (industryOption) => {
  return formatOption({ value: industryOption[0], label: industryOption[1].label });
};

/**
 *
 * @param props
 * @param industry
 * @param qObj
 * @returns {*[]}
 */
const getComputerSkillsCallback = (result, args) => {
  if (result.data === undefined || result.data.computer === undefined) {
    alert('Something went wrong. Please try again.  If the problem persists contact support.');
  } else {
    const stateProps = args.props.stateProps;

    const skills = [];
    const resumeIndex = stateProps.sectionData.resumeIndex;
    const resume = stateProps.dataToSave.saved.resumes[resumeIndex];
    const savedSkills = resume['computer-skills'] === undefined ? [] : resume['computer-skills'][0]['CS1'];
    const rawSkills = savedSkills.concat(result.data.computer);
    const existingSkills = [...new Set(rawSkills)];
    for (const skill of existingSkills) {
      const skillObj = {
        'key': skill,
        'label': skill,
        'value': skill,
      };
      skills.push(skillObj);
    }
    skills.sort(compare);
    resume.regenComputerSkills = false;
    resume.computerData = { options: skills };
    stateProps.setSpinnerImage('default.gif');
    stateProps.setSpinnerMessage('');
    stateProps.onSpinnerClose();
  }
};



/**
 *
 * @param props
 * @param uri
 * @param editableIndex
 * @param sectionType
 */
export const getComputerSkills = (stateProps, uri, editableIndex = 0, sectionType = 'section') => {

  const url = stateProps.domain + '/wp-json/rsworks/v1/computerSkills';
  const resumeIndex = stateProps.sectionData.resumeIndex;
  const job_title = stateProps.dataToSave.saved.resumes[resumeIndex].job_title;
  const industry = stateProps.dataToSave.saved.resumes[resumeIndex].industry[0];
  const request = {
    'target_role':job_title,
    'industry':industry,
  };
  const args = {
    props: { stateProps },
    message: 'Get Options',
  };
  stateProps.setSpinnerMessage('Your career is about to take off!\n'
    + 'Don’t forget to back up your hard drive...');
  stateProps.setSpinnerImage('computer.gif');
  stateProps.onSpinnerOpen();

  //stateProps.setLoadingSkills(true);
  runAxios(url, request, getComputerSkillsCallback, args);
};